<!-- 密码输入失败的提示弹窗 -->
<template>
  <van-popup
    v-model="show"
    position="bottom"
    round
    class="popup-notice"
    :class="isNewClass"
    :close-on-click-overlay="status !== 'error'"
  >
    <div class="popup-container" :class="[status, displayLayout]">
      <div
        class="header"
        v-if="
          status === 'errorLimit' || status === 'frozen' || status === 'appeal'
        "
      >
        <span>{{ $t('account.security_risk_alert') }}</span>
      </div>
      <div class="content">
        {{ noticeContent }}
      </div>
      <div class="popup-btn" :class="status">
        <template v-if="status === 'error'">
          <!-- 再试一次 -->
          <button class="btn btn-retry" @click="toRetry">
            {{ $t('account.retry') }}
          </button>
          <!-- 忘记密码 -->
          <button class="btn btn-info" @click="getPassword">
            {{ $t('account.retrieve_pw') }}
          </button>
        </template>
        <template v-else-if="status === 'appeal'">
          <!-- 账户申诉 -->
          <button class="btn btn-appeal" @click="toAppeal">
            {{ $t('accountAppeal.appeal_now') }}
          </button>
        </template>
        <template v-else>
          <!-- 重置密码 -->
          <button
            class="btn btn-info"
            @click="getPassword"
            v-if="frozenScene === 1 || status === 'errorLimit'"
          >
            {{ $t('account.reset_password') }}
          </button>
          <!-- 账户申诉 -->
          <button class="btn btn-appeal" @click="toAppeal">
            {{ $t('accountAppeal.appeal_now') }}
          </button>
        </template>
      </div>
    </div>
  </van-popup>
</template>
<script>
  import { mapState, mapGetters } from 'vuex'
  import { textFormat } from '@/utils/pluralRules.js'

  export default {
    name: 'confirm-notice',
    props: {
      status: {
        type: [String],
        require: true,
      },
      frozenScene: {
        type: Number,
        default: 0, // 冻结原因 1:密码输错次数过多 2:后台人工操作 3.发生拒付
      },
      value: [Boolean],
      query: {
        type: Object,
        default: () => {
          return {}
        },
      },
    },
    data() {
      return {
        show: this.value,
      }
    },
    computed: {
      ...mapState(['gameName']),
      ...mapGetters(['isNewClass', 'displayLayout']),
      suspendedText() {
        // 账户解封提醒
        return textFormat(this.$t('account.account_suspended_notice'), 12)
      },
      noticeContent() {
        const { status, frozenScene } = this
        if (status === 'errorLimit') {
          // 只可能在连续输错密码的情况下出现
          return this.suspendedText
        }
        if (status === 'error') {
          return this.$t('account.input_pw_err_tip') //密码输入错误
        }
        if (status === 'frozen') {
          if (frozenScene === 1) {
            return this.suspendedText
          } else {
            return this.$t('account.account_frozen') //实际翻译：系统监测您的账户存在安全问题,您的账户已被冻结
          }
        }
        if (status === 'appeal') {
          return this.$t(`ranking.restriction_reminder`) //You've reached your daily limit already. Come back tomorrow!
        }
        return ''
      },
    },
    watch: {
      value(val) {
        this.show = val
      },
      show(val) {
        this.$emit('input', val)
      },
    },
    methods: {
      toAppeal() {
        this.$router_push({
          path: `/account-appeal`,
          query: this.query,
        })
      },
      getPassword() {
        this.$emit('retreivePassword')
        this.show = false
      },
      toRetry() {
        // 重试
        // 关闭弹窗
        this.$emit('input', false)
        this.$emit('emptyInputPassword')
      },
    },
  }
</script>

<style lang="scss" scoped>
  .popup-notice {
    font-family: Roboto;
    .popup-container {
      padding: 90px 75px;
      &.error {
        .content {
          text-align: center;
        }
      }
    }
    .header {
      font-family: Roboto-Medium;
      margin-bottom: 60px;
      display: flex;
      align-items: center;
      justify-content: center;
      span {
        font-style: normal;
        font-weight: 500;
        font-size: 51px;
        line-height: 60px;
        color: #000;
      }
    }
    .content {
      font-weight: 400;
      font-size: 42px;
      line-height: 72px;
      color: #000;
      margin-bottom: 75px;
    }
    .btn {
      margin-bottom: 36px;
      width: 100%;
      height: 132px;
      background: transparent;
      border-radius: 100px;
      font-weight: 600;
      font-size: 48px;
      line-height: 64px;
      text-align: center;
      text-transform: uppercase;
      cursor: pointer;
    }
    .popup-btn {
      button:first-of-type {
        background: linear-gradient(114.2deg, #ff910f 15.3%, #ff450b 84.29%);
        color: #ffffff;
      }
      button:nth-of-type(2) {
        border: 3px solid #f96000;
        background: transparent;
        color: #f96000;
      }
    }
  }
  .popup-notice.is-new {
    background: $gray-popup;

    .header span {
      color: $white;
      font: 600 48px/65px 'Noto Sans';
    }
    .content {
      color: rgba(255, 255, 255, 0.7);
    }

    .btn {
      @include ok-btn();
    }

    .btn-info {
      @include cancel-btn();
    }
  }
</style>
<style scoped lang="scss">
  @media screen and (min-device-width: 1080px) {
    @import './Notice_pc.scss';
  }
</style>
